export class DeleteGaleryImageModel {
  public venueId: string;
  public venueGaleryImageIds: Array<string | undefined>;
}
